var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"logo"},[_c('span',[_vm._v(_vm._s(_vm.$website.title))]),_c('i',{staticClass:"iconfont icon-theme",on:{"click":_vm.switchTheme}})])
}
var staticRenderFns = []

export { render, staticRenderFns }